// en.js
module.exports = {
  我要: 'Hold',
  办赛: 'Competition',
  首页: 'Home',
  赛事专区: 'Events',
  产品中心: 'Products',
  机构: 'Agency',
  教练: 'Coach',
  运动员: 'Athletes',
  赛事: 'Match',
  参赛人次: 'Participants',
  赛事一站式服务平台: 'One-stop service platform for events',
  创建专属赛事官网: 'Create exclusive official website',
  赛事数据永久保存: 'The event data is stored permanently',
  智能报名规避错报: 'Intelligent registration avoids misreporting',
  一键抽签编排: 'One-click lottery arrangement',
  '一键下载秩序册、对战表': 'One click to download the order book, the battle table',
  智能检录呼叫号码: 'Intelligently record call numbers',
  智能竞赛设备: 'Intelligent competition equipment',
  成绩实时云同步: 'Results real-time cloud synchronization',
  一键制作参赛证奖状: 'One click to make the certificate',
  '参数数据、技术分析': 'Parameter data, technical analysis',
  竞赛物联网: 'Competition Internet of Things',
  '为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通':
    'Establish the Internet of Things for the competition equipment for the comprehensive sports meeting and all the competition systems of various events, and connect online and offline data',
  '裁判打分手柄/技术平板': 'Judges score the gamepad/tablet',
  '运动员穿戴设备、竞赛硬件设备': 'Wearing equipment',
  录像审议视频采集: 'Video review video collection',
  检录处发送检录通知: 'Push upon notice',
  现场终端: 'Terminal',
  记时记分比赛投屏: 'Score screen',
  比赛进程: 'The game process',
  '成绩、人气排行榜': 'Achievement, popularity list',
  技术统计数据分析: 'Analysis of technical statistics',
  比赛直播: 'The game live',
  比赛场次: 'Matches',
  竞赛项目: 'Competition items',
  近期赛事: 'Recent events',
  名称: 'Name',
  地区: 'Region',
  类型: 'Type',
  报名流程: 'Process',
  选择单位: 'Select organization',
  录入领队及教练: 'leader and coach',
  选手报名: 'Contestant registration',
  参赛选手: 'contestant',
  '报名完成/下载凭证': 'Registration completion / download voucher',
  '您还没有单位，请先创建一个参赛单位':
    'You do not have an organization, please create a participating organization first',
  赛事主页: 'Home',
  参赛数据: 'EntryData',
  场次对战: 'Battles',
  奖牌榜: 'Medal',
  赛事公告: 'Notice',
  组织机构: 'Event structure',
  报名时间: 'Registration time',
  比赛时间: 'Competition time',
  联系方式: 'Contact information',
  扫码进入小程序: 'Scan code to enter the applet',
  开赛时间: 'Start time',
  赛事地址: 'Event address',
  赛事级别: 'Event level',
  赛事热度: 'Competition heat',
  赛事附件: 'Event accessories',
  服务范围: 'Service scope',
  联系我们: 'Contact us',
  新媒体: 'New media',
  '智能报名100%规避错报': 'Intelligent registration 100% avoid misstatement',
  '一键抽签编排 覆盖全项目&全赛制': 'One-key draw arrangement covering all events & full tournament system',
  '一键制作参赛证、奖状': 'One-click production of entry card, certificate',
  客服工作时间: 'Service hours',
  '非工作时间我们不能及时回复您的信息，请在站内信留':
    'We cant reply your information in time during non working hours, please leave a message in the station',
  下问题或留下您的联系方式我们将在第一时间联系到您:
    'Next question or leave your contact information, we will contact you in the first time',
  道吧小程序: 'Daoba small program',
  道吧公众号: 'Daoba official account',
  选择带队成员: 'Select team leader',
  参赛人员信息填写: 'Information of participants',
  正在修改运动员的报名项目: 'Modifying athletes entry items',
  继续报名新运动员: 'Continue to register new athletes',
  选手姓名: 'Name',
  主教练: 'Chief coach',
  '* 主教练': '* Chief coach',
  领队: 'Leader',
  裁判: 'Referee',
  副教练: 'Assistant coach',
  经理: 'Manager',
  官员: 'official',
  队医: 'Team doctor',
  队长: 'Captain',
  点击添加: 'Add',
  上传证件照: 'Upload ID photo',
  身份证号: 'ID number',
  护照号: 'Passport No',
  必填: 'Required',
  '检测通过，自动获取身份证信息': 'Automatically obtain ID card information after passing the test',
  '点击检测，获取项目': 'Click Detect to get the item ',
  本平台购买保险无需上传保单: 'There is no need to upload insurance policies to purchase insurance on this platform',
  '点击检测，获取符合自身年龄段的项目': 'Click "detect" to obtain items that meet your age group',
  '请录入运动员信息后，点击检测': 'Please enter the athlete information and click test',
  没有检测到符合年龄的项目: 'No age matched items were detected',
  '注：提交之前请检查所报项目，以免错报或误报！':
    'PS：Please check the reported items before submission to avoid false report or false report！',
  报名提交: 'Registration',
  带队成员: 'Team leader',
  '报名须知：团体项目，请检查报名人数是否满足，若符合报名要求，即可进入到最后一步，下载凭证，若无法进入到下一步，请检查报名信息':
    'Registration instructions: for group projects, please check whether the number of applicants meets the requirements. If you meet the registration requirements, you can go to the last step and download the voucher. If you cannot go to the next step, please check the registration information',
  运动员参赛信息: 'Information of athletes',
  报名总人数: 'Total number of applicants',
  我已查看并同意: 'I have reviewed and agreed',
  保险条款: 'Insurance Clauses',
  客户告知书: 'Customer notification',
  报名完成下载凭证: 'Registration completion / download voucher',
  恭喜报名成功: 'Congratulations on your successful registration',
  下载报名列表: 'Download registration list',
  官方打印版: 'Official print version',
  完整信息版: 'Full information version',
  下载保险凭证: 'Download insurance certificate',
  '以机构名义报名参赛，重新选择机构': 'Register in the name of the organization and reselect the organization',
  上一步: 'Previous step',
  下一步: 'Next step',
  检查报名状态: 'enrollment status',
  '以个人身份报名参赛，进入选手报名': 'Enter as an individual to enter the competition',
  道吧赛事平台能为组委会: 'The Daoba event platform can serve the Organizing Committee',
  让天下没有难办的赛事: 'Let the world have no difficult events',
  节省: 'Save',
  人工: 'Labor',
  提高: 'Increase',
  的工作效率: 'Work efficiency',
  规避: 'Avoid',
  错报漏报: 'Misstatement',
  组委会: 'Organizing committee',
  '提供全项目&全赛制，一站式办赛服务支撑':
    'Provide full project & full competition system and one-stop service support',
  '以智能竞赛系统+竞赛设备双引擎，为国家体育总局、教育部、各省市体育协会、学校、俱乐部等办赛机构，':
    ' With the dual engines of intelligent competition system and competition equipment, it is the host organization of the National General Administration of sports, the Ministry of education, sports associations, schools and clubs in various provinces and cities, ',
  '提供从赛事运营、赛事执行、参赛数据统计&分析及赛事直播、后勤保障等线上+线下一站式服务支撑，':
    ' Provide online + offline one-stop service support from event operation, event execution, competition data statistics & analysis, event live broadcast, logistics support, etc, ',
  '服务已达34个省级行政区，90000+场次比赛':
    ' The service has reached 34 provincial administrative regions and 90000 + competitions',
  查看服务流程: 'View service process',
  主管部门: 'Competent department',
  '主管部门、体育协会': 'Competent departments and sports associations',
  '可以通过平台查询、管理辖区内历届各机构、参赛队及运动员的':
    'Through the platform, you can query and manage the information of all institutions, teams and athletes in the jurisdiction',
  '参赛数据，统计排名，并根据需求提供各种统计分析结果，':
    'Competition data, statistics and ranking, and provide various statistical analysis results according to needs, ',
  '便于主管部门了解当地体育单位的赛事状况，':
    'It is convenient for the competent authorities to understand the situation of local sports events,',
  对并未决策提供科学的数据依据: 'Provide scientific data basis for decision-making',
  查看详细介绍: 'View details',
  '运动队&运动员': 'Sports teams & Athletes',
  '随时掌握比赛进程；比赛信息互联互通':
    'Keep abreast of the progress of the game; Competition information interconnection',
  '检录提醒，及时提醒运动员在恰当时间去完成检录':
    'Recording reminder: timely remind athletes to complete the recording at an appropriate time',
  比赛过程中自动完成攻防双方技术统计: 'Automatically complete the technical statistics of both sides during the game',
  '提供对战双方攻防数据统计分析，便于进行赛后总结，':
    'Provide statistical analysis of the offensive and defensive data of both sides of the war to facilitate post game summary,',
  '针对性调整训练方法，有效提高运动员成绩': 'Adjust training methods to improve athletes performance',
  '所有比赛战绩、胜率、积分状况，技术指标等海量数据，实时完整的永久保存':
    'Massive data such as the performance, winning rate, score status and technical indicators of all competitions can be saved in real time and permanently',
  成功案例: 'Success stories',
  下载中心: 'Download Center',
  战略合作单位: 'Strategic cooperation unit',
  暂未上传数据: 'Data has not been uploaded yet',
  序号: 'Number',
  信息: 'Data',
  操作: 'action',
  案例准备中: 'Preparing case',
  下载: 'Download',
  修改资料: 'Modify data',
  个人报名运动员管理: 'Individual athlete management',
  我的机构: 'My organization',
  '你还没有自己的机构，点击创建机构': 'You dont have your own organization, click Create Organization',
  成为机构用户: 'Become an institutional user',
  授权机构: 'Authorized institution',
  添加授权账号: 'Add authorized account',
  简称: 'abbreviation',
  '注：简称将用于对战的队伍信息展示': 'Note: the abbreviation will be used for team information display',
  授权管理: 'Authorization',
  普通运动员: 'Athletes',
  团队管理: 'Team',
  球队管理: 'Team management',
  用于比分大图展示: 'It is used for the big picture display of scores',
  '注：用于比赛打分投屏（例图）': 'Note: It is used for match scoring and projection screen (example)',
  //服务流程
  赛事执行: 'Event execution',
  赛前: 'Pregame',
  比赛现场: 'game site',
  赛后: 'After the competition',
  创建赛事官网: 'Create the official website of the event',
  智能报名: 'Intelligent registration',
  生成参赛证: 'Generate entry certificate',
  资格审查系统: 'Qualification system',
  称重系统: 'weighing system',
  一键抽检编排: 'One click spot check arrangement',
  '秩序册、对战表下载': 'Order book and war table downloading',
  智能检录: 'Intelligent call',
  成绩实时云端同步: 'Real time cloud synchronization of scores',
  技术统计分析: 'Technical statistical analysis',
  '赛事录屏/直播': 'Event screen recording/live broadcast',
  '奖牌榜/人气榜': 'Medal List/Popularity List',
  智能体能监测设备: 'Intelligent physical fitness monitoring equipment',
  成绩册下载: 'Gradebook download',
  参赛视频下载: 'Competition video download',
  打印获奖证书: 'Print award certificates',
  多维度参赛数据分析: 'Multidimensional data analysis',
  外延服务: 'Outward service',
  保险团购: 'Group purchase of insurance',
  '奖杯 奖牌设计制作': 'Design and production of trophies and medals',
  '保赛事整体VI设计 及制作险团购': 'Overall VI design and production insurance group purchase',
  酒店预订: 'hotel reservation',
  赛场导航: 'Venue Navigation',
  餐厅预订: 'Restaurant reservation',
  智能叫车: 'Intelligent car hailing',
  酒店自动入驻: 'Automatic hotel entry',
  自动退房: 'Automatic check-out',
  网上签到: 'Sign in online',
  沟通需求: 'Communication needs',
  发送赛事规程: 'Send the rules',
  '专人沟通办赛内容、需求': 'Specially assigned person to communicate the content and needs of the event',
  将赛事规程发送给道吧服务专员: 'Send the competition rules to the service specialist of the Road Bar',
  组建赛事专属服务团队: 'Establish a dedicated service team for the event',
  '团队包含：软件工程师、硬件工程师、赛事督导赛事线上服务专员、赛事现场执行、VI设计':
    'The team includes: software engineer, hardware engineer, online service specialist for event supervision, event on-site execution, VI design',
  赛事财务统计: 'Event financial statistics',
  活动专区: 'Activity',
  运动员榜: 'Athletes',
  机构榜: 'Organizations',
  场馆: 'Venue',
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js